import React from "react";
import PropTypes from "prop-types";
import { FormControl, FormHelperText, Typography, Input } from "@mui/material";
import { withStyles } from "@mui/styles";

const EnhancedInput = ({ classes, label, caption, helperText, ...rest }) => (
  <FormControl fullWidth>
    {label && <Typography className={classes.label}>{label}</Typography>}
    {caption && <Typography variant="caption">{caption}</Typography>}
    <Input {...rest} />
    {helperText && <FormHelperText>{helperText}</FormHelperText>}
  </FormControl>
);

EnhancedInput.propTypes = {
  classes: PropTypes.object.isRequired,
  label: PropTypes.string,
  caption: PropTypes.string,
};

const styles = (theme) => ({
  label: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
});

export default withStyles(styles)(EnhancedInput);
